module.exports = __webpack_public_path__ + "static/media/Group-Yoga.b1feb35e.png";